// A Base64 encoded string...
export type Base64String = string & { readonly _: unique symbol };

// An HTML string
export type HtmlString = string & { readonly _: unique symbol };

// These are of the form "event.type.****" and are used to lookup translations from the
// language JSON files directly
export type EventType = string & { readonly _: unique symbol };

// This is a 2-letter country code eg: CA, US, etc.
export type CountryCode = string & { readonly _: unique symbol };

// This is a 2-letter region code eg: NL, AK, etc.
export type RegionCode = string & { readonly _: unique symbol };

export interface AddressResponse {
	street1?: string;
	street2?: string;
	city?: string;
	province?: RegionCode;
	country?: CountryCode;
	postal?: string;
}

export interface Address {
	street1: string;
	street2: string;
	city: string;
	provStateRegion: RegionCode | null;
	country: CountryCode | null;
	postalCode: string;
}

export interface ContactInfo {
	phone: string;
	extension: string;
	mobile: string;
	fax: string;
	webaddress: string;
}
export interface AddressWithContactInfoResponse extends AddressResponse {
	contactInfo?: Partial<ContactInfo>;
}

export interface AddressWithContactInfo extends Address {
	contactInfo: ContactInfo;
}

export enum SortDirection {
	ASC = 'asc',
	DESC = 'desc',
}

export interface PublicItemIsPublic<T> {
   isPublic: true;
   item: T;
}

export interface PublicItemIsNotPublic {
   isPublic: false;
   item: null;
}

export type PublicItem<T> = PublicItemIsPublic<T> | PublicItemIsNotPublic;
